import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import IconButton from '../IconButton';
import CloseIcon from '../Icons/Times';

const SpeechBubble = ({ text, onClose, textFontFamily }) => {
  const handleClose = () => {
    onClose(false);
  };

  if (!text) return null;

  return (
    <Root className="react-rnd-draggable-cancel" textFontFamily={textFontFamily}>
      <p>{text}</p>
      <IconButton onClick={handleClose} aria-label="the close button for speech bubble">
        <CloseIcon fill="#333" />
      </IconButton>
    </Root>
  );
};

SpeechBubble.propTypes = {
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  textFontFamily: PropTypes.string
};

const Root = styled.div`
  position: absolute;
  top: -12px;
  right: -4px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: max-content;
  max-width: 172px;
  padding: 8px 6px;
  font-family: ${props => props.textFontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  color: #333;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
  transform: translate(0%, -100%);

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    min-width: 150px;
  }

  p {
    margin: 0 2px 0 0;
  }

  ::after {
    content: '';
    position: absolute;
    right: 18px;
    bottom: -2.8px;
    height: 0px;
    width: 0px;
    margin-top: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent #fff #fff transparent;
    border-image: initial;
    box-shadow: 1.5px 1.5px 2px rgba(0, 0, 0, 0.15);
    transform: rotate(46deg);
    transform-origin: 0px 0px;
  }
`;

export default SpeechBubble;
